import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Suppress benign, cross-origin-masked errors (e.g. "Script error." and ResizeObserver
// loop notifications) so they don't surface as an uncaught-error overlay, especially when
// the app is opened via a shared/embedded link. Capture phase + stopImmediatePropagation
// preempts the dev error overlay's window listeners for these harmless cases only.
const isBenignError = (msg) =>
  typeof msg === "string" &&
  (msg === "Script error." ||
    msg === "Script error" ||
    msg.includes("ResizeObserver loop"));

window.addEventListener(
  "error",
  (e) => {
    if (isBenignError(e && e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

window.addEventListener("unhandledrejection", (e) => {
  const reason = e && e.reason;
  const msg = reason && (reason.message || reason);
  if (isBenignError(typeof msg === "string" ? msg : "")) {
    e.preventDefault();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
